import { styled } from 'styled-components';

export const TextArea = styled.textarea`
    color: rgb(68, 90, 100);
    resize: none;
    border: 1px #ddd solid;
    padding: 5px 10px;
    font-family: ${(props) => props.theme.app.font};
    font-size: ${(props) => props.theme.input.textSize};

    &:focus,
    &:active {
        outline: none;
    }
`;
